export default {
  name: 'CreditCardInfo',
  props: {
    card: Object
  },
  data: () => {
    return {
      ccTypeMask: {
        'American Express': 'xxxx-xxxxxx-x',
        'Diners Club': 'xxxx-xxxxxx-x',
        Discover: 'xxxx-xxxx-xxxx-',
        JCB: 'xxxx-xxxx-xxxx-',
        MasterCard: 'xxxx-xxxx-xxxx-',
        Visa: 'xxxx-xxxx-xxxx-'
      }
    };
  }
};